import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useLocalization } from './i18n/i18n'
import TopologyWebModuleV0 from './TopologyWebModuleV0'
import TopologyWebModuleModelV0 from './TopologyWebModuleModelV0'
import TopologyWebModuleV1 from './TopologyWebModuleV1'
import Placeholder from './components/Placeholder'
import useWindowDimensions from './hooks/useWindowDimensions'

function NoMatch() {
  const t = useLocalization()
  const { width, height } = useWindowDimensions()
  return (
    <Placeholder height={height} width={width}>
      {t('errNoRouteParam')}
    </Placeholder>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/v0/model/:patientId" element={<TopologyWebModuleModelV0 />} />
        <Route path="/v0/:route" element={<TopologyWebModuleV0 />} />
        <Route path="/v1/:route" element={<TopologyWebModuleV1 />} />
        <Route path="*" element={<NoMatch />} />
      </Routes>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
)
